__turbopack_context__.v({
  "row": "row-module-scss-module__Thi7-W__row",
  "row-col-1": "row-module-scss-module__Thi7-W__row-col-1",
  "row-col-2": "row-module-scss-module__Thi7-W__row-col-2",
  "row-col-3": "row-module-scss-module__Thi7-W__row-col-3",
  "row-col-4": "row-module-scss-module__Thi7-W__row-col-4",
  "row-col-5": "row-module-scss-module__Thi7-W__row-col-5",
  "row-col-6": "row-module-scss-module__Thi7-W__row-col-6",
  "spacing-compact": "row-module-scss-module__Thi7-W__spacing-compact",
  "spacing-default": "row-module-scss-module__Thi7-W__spacing-default",
});
